import { Initiative } from '@schema/initiative'
import { normalizePhoneInput } from '@app/util/helpers'
import type { ContactDetailsFormValues } from '@app/pages/dashboard/initiative/shared/validation/initiativeValidation'

export const contactDetailsDefaultValues = (
  initiative: Partial<Initiative>,
): ContactDetailsFormValues => ({
  contactFirstName: initiative.contactFirstName ?? '',
  contactLastName: initiative.contactLastName ?? '',
  contactEmail: initiative.contactEmail ?? '',
  contactPhoneNumber: normalizePhoneInput(initiative.contactPhoneNumber ?? ''),
})

export type ContactDetailsEditPayload = {
  contactFirstName: string
  contactLastName: string
  contactEmail: string
  contactPhoneNumber: string
}

export const contactDetailsToEditPayload = (
  values: ContactDetailsFormValues,
): ContactDetailsEditPayload => ({
  contactFirstName: values.contactFirstName,
  contactLastName: values.contactLastName,
  contactEmail: values.contactEmail,
  contactPhoneNumber: values.contactPhoneNumber,
})
